import { render, staticRenderFns } from "./AccessNiReport.vue?vue&type=template&id=405716f0"
import script from "./AccessNiReport.vue?vue&type=script&lang=js"
export * from "./AccessNiReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports